import { analyticsContext } from "../../layers/analytics/analytics";
import { css } from "../../ui/utils";
import { FC, useContext, useEffect } from "react";
import { Modal, ModalProps } from "../../ui/components/Modal/modal";
import { qrContext } from "../../context/qr/qr";
import { queriesContext } from "../../context/queries/queries";
import { typo } from "../../ui/styles";
import { useTranslation } from "react-i18next";
import styles from "./welcome.module.scss";

const Welcome: FC<ModalProps & { banners: Qr["welcomes"] }> = ({ banners, onClose, ...props }) => {
  const { i18n } = useTranslation();
  const triggerAnalytics = useContext(analyticsContext);
  const currentQr = useContext(qrContext);
  const { data: qr } = currentQr;
  const { query } = useContext(queriesContext);

  const currentBanner =
    banners.find(({ languages }) => languages.includes(i18n.language)) ||
    banners.find(({ languages }) => languages.includes(i18n.language.split("-")[0])) ||
    banners.find(({ isFallback }) => isFallback);

  useEffect(() => {
    if (qr) {
      if (query) {
        if (currentBanner?.images.length) {
          triggerAnalytics("WELCOME:VIEW", "");
        }
      }
    }
  }, [qr, query, currentBanner]);

  if (!currentBanner) return null;

  if (!currentBanner["images"].length) {
    return null;
  }

  return (
    <Modal
      bg={currentBanner["background"]}
      {...props}
      containerClassName={styles.container}
      className={css(typo.center, styles.modal)}
    >
      {currentBanner.images.map((image, index) => (
        <img
          key={index}
          className={styles["banner"]}
          src={image["path"]}
          onClick={(e) => {
            switch (image["action"]) {
              case "redirect": {
                triggerAnalytics(
                  "WELCOME:CLICK",
                  JSON.stringify({ action: "redirect", href: image["url"] })
                );
                window.open(image["url"]);
                break;
              }
              case "close": {
                triggerAnalytics("WELCOME:CLICK", JSON.stringify({ action: "close" }));
                onClose?.(e);
                break;
              }
            }
          }}
        />
      ))}
    </Modal>
  );
};

export { Welcome };
